import {signal} from "@preact/signals-react";

export const sellerDeepDiveReportFormIsOpen = signal(false)
export const sellerDeepDiveSubmittedFilters = signal({})